import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useToasts } from '../../../cdl/Toast/useToasts';
import { deleteAuthenticationMethod, deleteManagementAuthenticationMethod } from '../../../common/api/clients/mfa.api';
import { queries } from '../../../common/api/queryKeys/queries';
import { translate } from '../../../common/helpers/translate.helper';

export const useAuthenticationMethodDelete = (isAdminViewingOtherUser: boolean, userId: string) => {
    const queryClient = useQueryClient();
    const { addErrorToast } = useToasts();

    const userMutation = useMutation({
        mutationFn: ({ authenticationMethodId }: { authenticationMethodId: string }) =>
            deleteAuthenticationMethod({ authenticationMethodId }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queries.mfa.authenticationMethods.queryKey });
        },
        onError: () => {
            addErrorToast(translate('mfa.error.deleteFailed'));
        },
    });

    const managementMutation = useMutation({
        mutationFn: ({ authenticationMethodId }: { authenticationMethodId: string }) =>
            deleteManagementAuthenticationMethod({ authenticationMethodId, userId }),
        onSuccess: () => {
            queryClient.invalidateQueries(queries.mfa.managementAuthenticationMethods(userId));
        },
        onError: () => {
            addErrorToast(translate('mfa.error.deleteFailed'));
        },
    });

    return isAdminViewingOtherUser ? managementMutation : userMutation;
};
